import { Button, Card, CardContent, Typography } from "@mui/material";
import FruitifyIcon from "./FruitifyIcons";
import { Add } from "@mui/icons-material";
import React from "react";

export const ActionCard = ({
  iconName,
  title,
  subtitle,
  onAdd,
  titleAdornment,
}) => {
  return (
    <Card
      variant="outlined"
      data-testid={`action-card-${title}`}
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <FruitifyIcon name={iconName} variant="background" />
      <CardContent sx={{ mt: 2, mb: 2, flexGrow: 1 }}>
        <Typography variant="h5" color="secondary.main" gutterBottom>
          {title}
          {titleAdornment}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </CardContent>
      <Button
        sx={{ width: "100%" }}
        variant="outlined"
        startIcon={<Add />}
        onClick={onAdd}
      >
        Add
      </Button>
    </Card>
  );
};
